export const CARD_IMAGE_HEIGHT = 80;
export const CARD_TITLE_HEIGHT = 32;
export const LIST_VPADDING = 8;

export const FAMILY_MENU_HEIGHT = CARD_IMAGE_HEIGHT + CARD_TITLE_HEIGHT + LIST_VPADDING * 2;
